import { render, staticRenderFns } from "./personalTask.vue?vue&type=template&id=3ba79600&scoped=true&"
import script from "./personalTask.vue?vue&type=script&lang=js&"
export * from "./personalTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba79600",
  null
  
)

export default component.exports